var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert-edit-create',{attrs:{"organization-id":_vm.$auth.me.organization_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }